
import { Component, Vue } from 'vue-property-decorator'
import store from '../store'

@Component
export default class SetToastMessage extends Vue {
  set toast (value: string | false) {
    store.dispatch.notification.setMessage(value)
  }

  get toast () {
    return store.state.notification.message
  }
}
